/**
 * Kratka pamet na posledni objednavku.
 *
 * Po navratu z platebni brany zacina stranka nacistá – prohlizec byl
 * mezitim na cizi domene. Bez e-mailu se ale nelze zeptat na stav
 * platby, protoze ten je zaroven dukazem, ze objednavka patri tomu,
 * kdo se pta.
 *
 * `sessionStorage` je pro to spravna police: zije jen v jednom panelu
 * a po zavreni zmizi. Ulozeny e-mail uz zakaznik sam zadal o krok driv.
 */
const KEY = 'zooshopik:last-order';

export interface RememberedOrder {
  readonly orderNumber: string;
  readonly email: string;
}

export function rememberOrder(orderNumber: string, email: string): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ orderNumber, email }));
  } catch {
    // Prohlizec v rezimu bez uloziste. Dekovacka pak jen neukaze stav.
  }
}

/** Vrati ulozenou objednavku, jen kdyz jde o tu, na kterou se ptame. */
export function recallOrder(orderNumber: string): RememberedOrder | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (raw === null) return null;
    const parsed = JSON.parse(raw) as Partial<RememberedOrder>;
    if (parsed.orderNumber !== orderNumber || typeof parsed.email !== 'string') return null;
    return { orderNumber, email: parsed.email };
  } catch {
    return null;
  }
}
